module.exports = __webpack_public_path__ + "static/media/safari.3a37064d.svg";